import { ApolloError, useQuery } from '@apollo/client';

import { FilteredDispensariesDocument } from 'src/gql/graphql';
import type { Dispensaries, FilteredDispensariesQuery as FilteredDispensariesQueryResult } from 'src/gql/graphql';
import { getLogger } from 'src/utils/datadog-logger';
import { LOG_NAMESPACES } from 'src/payments/constants';

const logger = getLogger(LOG_NAMESPACES.PBB_INSTORE_CART);

type FilteredDispensariesResponse = Pick<Dispensaries, 'name' | 'SpecialLogoImage'> & {
  logo: string;
  name: string;
  dispensaryId: string;
};

export type FilteredDispensariesQuery = {
  data?: FilteredDispensariesResponse;
  loading?: boolean;
  error?: ApolloError;
};

type UseFilteredDispensaries = {
  skip: boolean;
  dispensaryId: string;
};

function filteredDispensariesResponseAdapter(
  dispensaryId: string,
  response?: FilteredDispensariesQueryResult
): FilteredDispensariesResponse | undefined {
  const dispensaryInfo = response?.filteredDispensaries?.[0];

  if (dispensaryInfo == null) {
    return undefined;
  }

  return {
    logo: dispensaryInfo.SpecialLogoImage ?? '',
    name: dispensaryInfo.name ?? '',
    dispensaryId,
  };
}

export default function useFilteredDispensaries({
  skip,
  dispensaryId,
}: UseFilteredDispensaries): FilteredDispensariesQuery {
  const { data, loading, error } = useQuery(FilteredDispensariesDocument, {
    variables: { dispensaryId },
    skip,
  });

  if (error) {
    logger.error('useFilteredDispensariesQuery Error', { error, dispensaryId });
  }

  return { data: filteredDispensariesResponseAdapter(dispensaryId, data), loading, error };
}
